// ------------------------------
// Utilities
// ------------------------------
function refreshCart() {
  console.log("🔄 [refreshCart] Start");

  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then(res => res.text())
    .then(htmlText => {
      const html = new DOMParser().parseFromString(htmlText, 'text/html');

      // ── 1. Core cart content & footer ──────────────────────────────
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      selectors.forEach(sel => {
        const target = document.querySelector(sel);
        const source = html.querySelector(sel);
        if (target && source) {
          target.replaceWith(source);
          console.log(`✅ Replaced: ${sel}`);
        }
      });

      // ── 2. Sync is-empty class on <cart-drawer> ────────────────────
      const targetDrawer = document.querySelector('cart-drawer');
      const sourceDrawer = html.querySelector('cart-drawer');
      if (targetDrawer && sourceDrawer) {
        if (sourceDrawer.classList.contains('is-empty')) {
          targetDrawer.classList.add('is-empty');
        } else {
          targetDrawer.classList.remove('is-empty');
        }
        console.log(`✅ is-empty synced: ${targetDrawer.classList.contains('is-empty')}`);
      }

      // ── 3. Replace drawer header (cart count bubble) ───────────────
      const targetHeader = document.querySelector('.drawer__header');
      const sourceHeader = html.querySelector('.drawer__header');
      if (targetHeader && sourceHeader) {
        targetHeader.replaceWith(sourceHeader);
        console.log(`✅ Replaced: .drawer__header`);
      }

      // ── 4. Progress bar ────────────────────────────────────────────
      const targetProgress = document.querySelector('#cart-progress-wrapper');
      const sourceProgress = html.querySelector('#cart-progress-wrapper');

      if (targetProgress && !sourceProgress) {
        // Cart became empty — hide the bar
        targetProgress.style.display = 'none';
        console.log('✅ Progress bar hidden (cart empty)');
      } else if (!targetProgress && sourceProgress) {
        // Cart went from empty → has items — re-inject after header
        const header = document.querySelector('.drawer__header');
        if (header) {
          header.after(sourceProgress);
          console.log('✅ Progress bar injected (cart has items)');
        }
      } else if (targetProgress && sourceProgress) {
        // Cart updated normally — replace with fresh values
        targetProgress.replaceWith(sourceProgress);
        console.log('✅ Progress bar updated');
      }

      // ── 5. Empty state block (.drawer__inner-empty) ────────────────
      const targetInner = document.querySelector('.drawer__inner');
      const sourceInner = html.querySelector('.drawer__inner');
      if (targetInner && sourceInner) {
        const sourceEmpty = sourceInner.querySelector('.drawer__inner-empty');
        const targetEmpty = targetInner.querySelector('.drawer__inner-empty');

        if (sourceEmpty && !targetEmpty) {
          // Cart just became empty — inject empty state
          targetInner.insertAdjacentElement('afterbegin', sourceEmpty);
          console.log(`✅ Injected empty state`);
        } else if (!sourceEmpty && targetEmpty) {
          // Cart is no longer empty — remove empty state
          targetEmpty.remove();
          console.log(`✅ Removed empty state`);
        }
      }
      // ── 6. Update header cart count ────────────────────────────────
      updateHeaderCartCount();

      console.log("✅ [refreshCart] Completed");
    })
    .catch(e => console.error("❌ [refreshCart] Error:", e.message));
}

// ------------------------------
// Update Header Cart Count
// ------------------------------
async function updateHeaderCartCount() {
  try {
    const cart = await fetchCartData();
    if (!cart) return;

    const count = cart.item_count;
    const bubble = document.querySelector('#cart-icon-bubble');
    if (!bubble) return;

    // Update the visible count span
    const countSpan = bubble.querySelector('span[aria-hidden="true"]');
    if (countSpan) {
      countSpan.textContent = count > 0 ? `(${count})` : '(0)';
    }

    // Update the visually hidden "X item" span
    const hiddenSpans = bubble.querySelectorAll('.visually-hidden');
    hiddenSpans.forEach(span => {
      if (span.textContent.includes('item')) {
        span.textContent = count === 1 ? '1 item' : `${count} items`;
      }
    });

    console.log(`✅ Header cart count updated → ${count}`);
  } catch (e) {
    console.error("❌ updateHeaderCartCount Error:", e.message);
  }
}

async function fetchCartData() {
  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
    return await res.json();
  } catch (e) {
    console.error("❌ fetchCartData Error:", e.message);
    return null;
  }
}

async function updateCartItemQuantityByVariantId(variantId, quantity) {
  const cart = await fetchCartData();
  if (!cart) return;

  const lineItem = cart.items.find(i =>
    i.variant_id === Number(variantId) &&
    i.properties && i.properties._is_gwp
  );

  if (!lineItem) return console.warn(`[updateQty] GWP Variant ${variantId} not found`);

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineItem.key,
        quantity
      })
    });

    if (!res.ok) throw new Error('Cart update failed');
    console.log(`✅ Updated GWP ${variantId} → Qty ${quantity}`);
  } catch (e) {
    console.error("❌ updateCartItemQuantity Error:", e.message);
  }
}

async function addGiftProduct(variantId, quantity = 1) {
  console.log(`🎁 Adding gift ${variantId} Qty: ${quantity}`);
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { free_product_variant_id: variantId }
      })
    });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties: {
          _is_gwp: 'true'
        }
      })
    });

    if (!res.ok) throw new Error('Gift add failed');
    console.log(`✅ Gift added ${variantId}`);
  } catch (e) {
    console.error("❌ addGiftProduct Error:", e.message);
  }
}

async function removeGiftProduct(variantId) {
  console.log(`🗑️ Removing gift ${variantId}`);

  const cart = await fetchCartData();
  if (!cart) return;

  const item = cart.items.find(i =>
    i.variant_id === Number(variantId) &&
    i.properties && i.properties._is_gwp
  );

  if (!item) {
    console.warn(`[removeGiftProduct] GWP ${variantId} not found`);
    return;
  }

  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: 0
      })
    });

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { free_product_variant_id: '' }
      })
    });

    console.log(`✅ Gift removed ${variantId}`);
  } catch (e) {
    console.error("❌ removeGiftProduct Error:", e.message);
  }
}

// ------------------------------
// Main GWP Logic
// ------------------------------
let gwpCheckTimeout;
async function checkGWP() {
  if (gwpCheckTimeout) clearTimeout(gwpCheckTimeout);
  gwpCheckTimeout = setTimeout(async () => {
    const gwpInputs = document.querySelectorAll('.single_gwp_input');
    if (!gwpInputs.length) return;

    const cart = await fetchCartData();
    if (!cart) return;

    console.log(`🛒 Cart total: ${cart.item_count}, Lines: ${cart.items.length}`);

    for (const gwpInput of gwpInputs) {
      const mainSingleId = Number(gwpInput.dataset.gwpMainSingleVariantId);
      const singleGiftId = Number(gwpInput.dataset.gwpSingleVariantId);
      const mainComboId = Number(gwpInput.dataset.mainProductId);
      const comboGiftId = Number(gwpInput.dataset.gwpVariantId);

      const mainSingleItem = cart.items.find(i => i.variant_id === mainSingleId);
const singleGiftItem = cart.items.find(i =>
  i.variant_id === singleGiftId &&
  i.properties && i.properties._is_gwp
);
      const mainComboItem = cart.items.find(i => i.variant_id === mainComboId);
const comboGiftItem = cart.items.find(i =>
  i.variant_id === comboGiftId &&
  i.properties && i.properties._is_gwp
);

      // -------------------- SINGLE gift logic
      if (mainSingleItem) {
        const requiredQty = mainSingleItem.quantity * 1;
        if (!singleGiftItem) await addGiftProduct(singleGiftId, requiredQty);
        else if (singleGiftItem.quantity !== requiredQty) await updateCartItemQuantityByVariantId(singleGiftId, requiredQty);
      } else if (singleGiftItem) {
        await removeGiftProduct(singleGiftId);
      }

      // -------------------- COMBO gift logic
      if (mainComboItem) {
        const requiredQty = mainComboItem.quantity;
        if (!comboGiftItem) await addGiftProduct(comboGiftId, requiredQty);
        else if (comboGiftItem.quantity !== requiredQty) await updateCartItemQuantityByVariantId(comboGiftId, requiredQty);
      } else if (comboGiftItem) {
        await removeGiftProduct(comboGiftId);
      }
    }

    console.log("✅ GWP check complete → refreshing cart");
    refreshCart();
  }, 300); // debounce multiple triggers
}

// ------------------------------
// Event Listeners
// ------------------------------
document.addEventListener('submit', e => {
  const form = e.target.closest('form[action^="/cart/add"]');
  if (!form) return;
  setTimeout(checkGWP, 1200);
});

document.addEventListener('click', e => {
  const isQtyBtn = e.target.closest("#CartDrawer .quantity__button");
  const isRemoveBtn = e.target.closest("#CartDrawer .cart-remove-button");
  if (isQtyBtn || isRemoveBtn) setTimeout(checkGWP, 1000);
});

// document.addEventListener('DOMContentLoaded', () => {
//   setTimeout(checkGWP, 500);
// });

// ------------------------------
// Override fetch for cart add
// ------------------------------
(function() {
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    const res = await originalFetch.apply(this, args);
    if (args[0].includes('/cart/add')) setTimeout(checkGWP, 300);
    return res;
  };
})();
